//オリジナルのjs


/*端末ごとの振り分け(重要)*/
	var ua = navigator.userAgent;
	if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0) && (ua.indexOf('Mobile') > 0) || ua.indexOf('Windows Phone') > 0) {
		//location.href = 'sp/';
	}else if(ua.indexOf('iPad') > 0  || ua.indexOf('Macintosh') > 0 || ua.indexOf('Android') > 0){
		document.write('<meta name="viewport" content="width=1400">');
	}




//呼吸するパジャマとは ドロップダウン
$( function() {
	$( 'body' ).on( 'click', '.dropDownBtn._01 > p', function() {
		$( '.dropDownBtn._01 > p' ).toggleClass( 'active' );
		$( '.dropDownCont._01' ).toggleClass( 'active' );
	} );
} );
$( function() {
	$( 'body' ).on( 'click', '.dropDownBtn._02 > p', function() {
		$( '.dropDownBtn._02 > p' ).toggleClass( 'active' );
		$( '.dropDownCont._02' ).toggleClass( 'active' );
	} );
} );
$( function() {
	$( 'body' ).on( 'click', '.dropDownBtn._03 > p', function() {
		$( '.dropDownBtn._03 > p' ).toggleClass( 'active' );
		$( '.dropDownCont._03' ).toggleClass( 'active' );
	} );
} );





/*smooth-header固定時-*/
jQuery(function() {
    var H_nav = $(".header-wrapper").height();
    function pagelink(heightnum) {
        var headerH = heightnum;
        jQuery('a[href*="#"]:not(.ez-toc-list a)').click(function() {
				let target = $(this.hash);
				if (!target.length) return;
				var position = target.offset().top - headerH;
				$("html, body").animate({ scrollTop: position }, 500, "swing");
				return false;
			});
    }
    pagelink(H_nav);
});



//smooth-header固定時ページ遷移位置調整
$(window).on('load', function() {
	const url = $(location).attr('href'),
	headerHeight = $('.header-wrapper').outerHeight() + 0;
	if(url.indexOf("#") != -1){
		const anchor = url.split("#"),
		target = $('#' + anchor[anchor.length - 1]),
		position = Math.floor(target.offset().top) - headerHeight;
		$("html, body").animate({scrollTop:position}, 500);
	}
});
